// src/axiosConfig.js
import axios from "axios";

const getBaseDomain = () => {
  const envUrl = process.env.REACT_APP_API_URL;
  if (envUrl) return envUrl.replace(/\/api\/?$/, "").replace(/\/+$/, "");
  return "http://localhost:8000";
};

export const BASE_DOMAIN = getBaseDomain();

const api = axios.create({
  baseURL: `${BASE_DOMAIN}/api`,
  withCredentials: true,

  // ✅ IMPORTANT: forces axios to attach X-XSRF-TOKEN even when port differs
  withXSRFToken: true,

  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
});

api.defaults.xsrfCookieName = "XSRF-TOKEN";
api.defaults.xsrfHeaderName = "X-XSRF-TOKEN";

let _csrfPromise = null;

export const ensureCsrfCookie = () => {
  if (!_csrfPromise) {
    _csrfPromise = api
      .get("/sanctum/csrf-cookie", {
        baseURL: BASE_DOMAIN,
        withCredentials: true,
        withXSRFToken: true,
      })
      .catch((err) => {
        _csrfPromise = null;
        throw err;
      });
  }
  return _csrfPromise;
};

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const config = error?.config;
    const status = error?.response?.status;

    if (!config || config.__retried) return Promise.reject(error);
    if (status !== 419 && status !== 403) return Promise.reject(error);
    if (String(config.url || "").includes("/sanctum/csrf-cookie")) return Promise.reject(error);

    config.__retried = true;
    _csrfPromise = null; // force fresh token on retry
    await ensureCsrfCookie();
    return api(config);
  }
);

export default api;
